/***
 * Created on 2023/9/1
 * @author: Adam Cheng <adamcheng@qnap.com>
 ***/
import React from 'react';
import ModalDialog from "./modalDialog";
import {useTranslation} from "react-i18next";

function ShowSigninAgainDialog({...props}) {
    const { t } = useTranslation();

    const defaultAction = async () => {
        location.href = '/signout';
    }

    return (
        <ModalDialog title={t('@Sign in again@')}
                     submitText={t('@Sign in again@')}
                     submitAction={defaultAction}
                     hideCancel={true} {...props}>
            <div className="dialog-content">
                <p>
                    {t('@Please sign in your QNAP ID on all of your browsers, QNAP mobile apps, and KoiBot again.@')}
                </p>
            </div>
        </ModalDialog>
    );
}

export default ShowSigninAgainDialog;